(function () {
  'use strict';

  angular.module('dashboard.main', ['ngResource']);
})();
